var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4888_14640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 4.63307V16.6301C0.000244141 17.7347 0.460489 18.7166 1.19688 19.4836C1.93327 20.22 2.88444 20.6189 3.98903 20.6189H10.0029V18.1336H3.98903C3.16059 18.1336 2.51625 17.4586 2.51625 16.6301V4.63307C2.51625 3.80463 3.16059 3.16029 3.98903 3.16029H10.0029V0.644287H3.98903C2.88444 0.644287 1.93327 1.07385 1.19688 1.81024C0.460489 2.57731 0.000244141 3.52849 0.000244141 4.63307ZM6.59708 8.25366V13.0402C6.59708 13.5925 7.08801 14.0527 7.64031 14.0527H13.1939V17.8268C13.1939 18.1643 13.378 18.4404 13.6849 18.5938C13.8076 18.6245 13.9303 18.6245 13.9917 18.6245C14.2065 18.6245 14.3906 18.5631 14.544 18.4097L21.7545 11.1992C22.092 10.9231 22.0613 10.3708 21.7545 10.064L14.544 2.88414C14.1144 2.4239 13.1939 2.70005 13.1939 3.43644V7.24113H7.64031C7.08801 7.24113 6.59708 7.70137 6.59708 8.25366Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4888_14640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20.619,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6609ac73c1d1b72a8d01168da6423ae4.svg";
export { ForwardRef as ReactComponent };